export default {
    visibilityFilter: 'Visibility',
    placeholderSearch: 'Suche',
    teamFilter: 'Teams',
    stateSelect: 'State',
    minValue: 'From',
    maxValue: 'To',
    search: 'Text search',
    placeholder: 'Enter text here',
    app: 'App',
    webapp: 'Webapp',
    assembly: '3D-Group',
    model: '3D-Element',
    helper: 'vHelper',
    tbl: 'Table',
    obj: 'Object',
    sensor: 'Sensor',
    feed: 'Feed',
    typeSelect: 'Type Selection',
    tagFilter: 'Tags',
    orgFilter: 'Organizations',
    fieldSelector: 'Filter a field',
    all: 'All',
    none: 'None',
    private: 'Private',
    public: 'Public',
    global: 'Global',
}